// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ConditionsIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ConditionsIcon" ref={forwardedRef} {...props}>
      <path d="M2 9.257h6v1.5H2z" />
      <path d="M8 14a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-.5H9.5v-7H15V6a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1z" />
      <path d="M14.172 2.894 17 5.723 14.172 8.55l-1.063-1.06 1.77-1.77-1.766-1.766z" />
      <path d="M14.172 11.334 17 14.162l-2.828 2.829-1.063-1.063 1.77-1.77-1.766-1.765z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ConditionsIcon = /* @__PURE__ */ Object.assign(
  ConditionsIconComponent,
  { displayName: 'ConditionsIcon' },
);
